// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-11QBb","flights":"flights-fxCzn","planeIcon":"planeIcon-1UtiL","flight":"flight-KXGeE","flight_noMargin":"flight_noMargin-2FM0z"};